import { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { fetchCustomerById, updateCustomerApplication } from '../../api/customer';

import Swal from 'sweetalert2';
import StepProgress from '../../components/StepProgress';
import Step1 from './steps/Step1_AccountInfo';
import Step2 from './steps/Step2_AddressInfo';
import Step3 from './steps/Step3_ContactInfo';
import Step4 from './steps/Step4_Requirements';
import Step5 from './steps/Step5_BillInfo';
import Step6 from './steps/Step6_Confirm';

const ApplicationForm = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const [formData, setFormData] = useState({});
    const [step, setStep] = useState(1);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadCustomer = async () => {
            if (id) {
                try {
                    const res = await fetchCustomerById(id);
                    const data = res.data.data;

                    setFormData({
                        ...data,
                        govtIdType: data.idTypeText,
                        govtIdNumber: data.idNumber,
                        seniorId: data.oscaId,
                        seniorDate: data.scDateStart,
                        email: data.contactEmail,
                    });
                } catch (err) {
                    console.error('Failed to load customer:', err);
                }
            }
            setLoading(false);
        };

        loadCustomer();
    }, [id]);

    const handleNext = () => setStep((prev) => Math.min(6, prev + 1));
    const handleBack = () => setStep((prev) => Math.max(1, prev - 1));

    const handleSubmit = async () => {
        try {
            await updateCustomerApplication(id, formData);

            Swal.fire({
                icon: 'success',
                title: 'Application Submitted!',
                text: 'Customer profile has been verified successfully.',
                confirmButtonText: 'OK'
            }).then(() => {
                navigate('/crm/customers'); // ✅ redirect only after user confirms
            });
        } catch (err) {
            console.error('Error submitting application:', err);
            alert('There was an error. Please try again.');
        }
    };


    const steps = {
        1: <Step1 formData={formData} setFormData={setFormData} />,
        2: <Step2 formData={formData} setFormData={setFormData} />,
        3: <Step3 formData={formData} setFormData={setFormData} />,
        4: <Step4 formData={formData} setFormData={setFormData} />,
        5: <Step5 formData={formData} setFormData={setFormData} />,
        6: <Step6 formData={formData} />
    };

    if (loading) return <p>Loading...</p>;

    return (
        <div>
            <h3 className="mb-4">{id ? 'Update Application' : 'New Service Application'}</h3>
            <StepProgress currentStep={step} />

            {steps[step]}

            <div className="d-flex justify-content-between mt-4">
                <Button variant="secondary" onClick={handleBack} disabled={step === 1}>
                    Back
                </Button>
                {step < 6 ? (
                    <Button variant="primary" onClick={handleNext}>
                        Next
                    </Button>
                ) : (
                    <Button variant="success" onClick={handleSubmit}>
                        Verify Application Information
                    </Button>
                )}
            </div>
        </div>
    );
};

export default ApplicationForm;
